"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logPerformanceMarkers = void 0;
var bernie_client_events_1 = require("../events/bernie-client-events");
var logPerformanceMarkers = function (beaconData, logger, performanceApiData, pageUsableTime) {
    try {
        beaconData.message = 'page loaded';
        if (window) {
            if (pageUsableTime) {
                beaconData.pageUsable = pageUsableTime;
            }
            if (window.performance && window.performance.timing) {
                if (window.performance.timing.toJSON) {
                    performanceApiData = window.performance.timing.toJSON();
                }
                else {
                    var timing = window.performance.timing;
                    for (var key in timing) {
                        if (typeof timing[key] === 'number') {
                            performanceApiData[key] = timing[key];
                        }
                    }
                }
                if (performanceApiData.responseStart && performanceApiData.fetchStart) {
                    beaconData.ttfb = performanceApiData.responseStart - performanceApiData.fetchStart;
                }
                if (performanceApiData.domainLookupEnd && performanceApiData.domainLookupStart) {
                    beaconData.dns = performanceApiData.domainLookupEnd - performanceApiData.domainLookupStart;
                }
                if (performanceApiData.connectEnd && performanceApiData.connectStart) {
                    beaconData.tcp = performanceApiData.connectEnd - performanceApiData.connectStart;
                }
            }
        }
        logger.performance(beaconData);
    }
    catch (error) {
        logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.CATALOGED_DATA_CAPTURE_ERROR, error);
    }
};
exports.logPerformanceMarkers = logPerformanceMarkers;
//# sourceMappingURL=log-performance-markers.js.map